import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6dcdbd4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b6dcdbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dcdbd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6dcdbd4')) {
      api.createRecord('b6dcdbd4', component.options)
    } else {
      api.reload('b6dcdbd4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b6dcdbd4&scoped=true&", function () {
      api.rerender('b6dcdbd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/intake/children/detail/components/components/PostListAll/index.vue"
export default component.exports